import Api from './Api';

class CampanhaService {
  constructor() {
    this.$api = Api;
  }

  async findAll(filters) {
    return this.$api.get('/campanhas', filters);
  }

  async save(data) {
    const id = data.id || 0;

    if (id === 0) {
      return this.$api.post('/campanha', data);
    }

    return this.$api.put(`/campanha/${id}`, data);
  }

  async findById(id) {
    return this.$api.get(`/campanha/${id}`);
  }

  async remove(id) {
    return this.$api.delete(`/campanha/${id}`);
  }
}

export default new CampanhaService();
